import React from 'react';
import PropTypes from 'prop-types';

function MediaIcon(props) {
  if (props.type === 'photostory') {
    return <i className="icon photos" />;
  } else if (props.type === 'video') {
    return <i className="icon videos" />;
  }
  return null;
}

MediaIcon.propTypes = {
  type: PropTypes.string,
};

MediaIcon.defaultProps = {
  type: '',
};

export default MediaIcon;
